<div class="paybee-modal-header">
    <div class="row">
        <div class="col-11">
            <div class="modal-main-heading">Bid Info</div>
        </div>
        <div class="col-1">
            <button (click)="close()" type="button" class="close">
                <span aria-hidden="true" class="black-text">&times;</span>
            </button>
        </div>    
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">SOME TEXT</div>
        </div>
    </div>
</div>
<div class="modal-body custom-material-form updated-dropdown" [formGroup]="auctionBidderInfoForm">
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill form-outline disabled">
                <app-mdbp-input mdbInput formControlName="nameInput" [showMaxLength]="false" label='Name'></app-mdbp-input>
            </mdb-form-control>
            <mdb-form-control class="form-fill form-outline disabled">
                <app-mdbp-input mdbInput formControlName="emailInput" [showMaxLength]="false" label='Email'></app-mdbp-input>
            </mdb-form-control>
            
            <ng-container *ngIf="campaign.phoneNumRequired">
                <mdb-form-control class="form-fill form-outline disabled">
                    <app-mdbp-input mdbInput formControlName="phoneInput" [showMaxLength]="false" label='Phone'></app-mdbp-input>
                </mdb-form-control>
            </ng-container>
            
            <ng-container *ngIf="campaign.streetAddressRequired">
                <mdb-form-control class="form-fill form-outline disabled">
                    <app-mdbp-input mdbInput formControlName="addressInput" [showMaxLength]="false" label='{{campaign.streetAddressReason}}'></app-mdbp-input>
                </mdb-form-control>
            </ng-container>

            <ng-container *ngIf="campaign.additionalInfoDesc">
                <mdb-form-control class="form-fill form-outline disabled">
                    <app-mdbp-input mdbInput formControlName="addInfoInput" [showMaxLength]="false" label='{{campaign.additionalInfoDesc}}'></app-mdbp-input>
                </mdb-form-control>
            </ng-container>
            

            <ng-container *ngIf="campaign.additionalInfoSelectDesc">
                <mdb-form-control class="form-fill disabled">
                    <mdb-select formControlName="addInfoSelectInput" class="mdb-select">
                        <mdb-option *ngFor="let option of campaign.additionalInfoSelect" [value]="option">{{option}}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">{{campaign.additionalInfoSelectDesc}}</label>
                </mdb-form-control>
            </ng-container>
        </div>
    </div>
</div>
<div class="modal-footer paybee-modal-footer">
    <a (click)="close()" class="btn btn-sm modal-confirm-button">Close</a>
</div>